// Frontend configuration
export const config = {
  // API Configuration
  apiUrl: import.meta.env.VITE_API_URL || 'https://pumpbot-kaxg.onrender.com',
  
  // Site Configuration
  siteName: import.meta.env.VITE_SITE_NAME || 'FixSlop',
  siteDescription: import.meta.env.VITE_SITE_DESCRIPTION || 'The fastest way to create professional memecoin landing pages',
  baseDomain: import.meta.env.VITE_BASE_DOMAIN || 'fixslop.xyz',
  
  // Generation Configuration
  maxFileSize: 5 * 1024 * 1024, // 5MB
  supportedImageTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  
  // Social Media Links
  socialLinks: {
    github: 'https://github.com',
    twitter: 'https://twitter.com',
    discord: 'https://discord.com'
  },
  
  // DEX Platforms
  dexPlatforms: [
    { id: 'pumpswap', name: 'PumpSwap', network: 'ethereum' },
    { id: 'pancakeswap', name: 'PancakeSwap', network: 'bsc' },
    { id: 'raydium', name: 'Raydium', network: 'solana' },
    { id: 'jupiter', name: 'Jupiter', network: 'solana' },
    { id: 'dexscreener', name: 'DexScreener', network: 'solana' }
  ],
  
  // Theme Configuration
  themes: {
    default: {
      primary: '#0ea5e9',
      secondary: '#d946ef',
      accent: '#f59e0b'
    }
  }
}

export default config 